import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';
import { ApiService } from 'src/app/services/api/api.service';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-content-cards',
    templateUrl: './pb-content-cards.component.html',
    styleUrls: ['./pb-content-cards.component.scss']
})
export class PbContentCardsComponent implements OnInit {

    @Input() module: any = {};
    slides: any = [];

    // A swiper config which is responsive and shows partial slides

    public responsivePartialOverflowConfig: any = {
        slidesPerView: 1.1,
        spaceBetween: 15,
        freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        centerInsufficientSlides: true,
        pagination: { clickable: true },
        breakpoints: {
            576: {
                slidesPerView: 2.1
            },
            768: {
                slidesPerView: 3.1
            },
            992: {
                slidesPerView: 4
            }
        }
    };

    constructor(private api: ApiService, private cd: ChangeDetectorRef) { }

    ngOnInit(): void {

        this.fetchContentCards();

    }

    /**
     * When 'Why Study with us' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onWhyStudySwiper(swiper) {

        setTimeout(() => {
            //swiper.update();
        }, 1500);

    }

    async fetchContentCards() {

        await this.api.fetch_content_cards()
            .subscribe(res => {
                this.slides = res.data.items;
                this.slides.forEach((card, index) => {
                    this.slides[index].description = JSON.parse(card.description); 
                });
                this.slides = this.slides.filter(card => card.published);
                this.cd.detectChanges();
            }, (err) => {
                console.log(err);
            });

    }

}
